import { Spinner, makeStyles } from '@fluentui/react-components';
import React from 'react';
import { customColors, customFonts } from '../../styles';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        padding: '80px',
        fontFamily: customFonts.Lato,
        boxSizing: 'border-box',
    },
    spinner: {
        '& > span > svg > circle:nth-child(2)': {
            path: customColors.protivitiOrange,
            stroke: customColors.protivitiOrange,
        },
    },
});

interface LoadingProps {
    text?: string;
}

export const Loading: React.FC<LoadingProps> = ({ text = 'Loading...' }) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Spinner labelPosition="below" label={text} className={classes.spinner} />
        </div>
    );
};

export default Loading;
